<template>
  <router-view/>
</template>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
    margin: 0;
    font-family: Helvetica, sans-serif;
}

button {
    cursor: pointer;
    transition: all 0.2s ease-in-out;
}

select {
    cursor: pointer;
}

html {
    font-family: Helvetica, sans-serif;
    font-size: 14px;
}
</style>
